import styled from 'styled-components';
import { Colors, Fonts } from '../../theme';

export const ContainerDiv = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : Colors.backgroundGray};
  height: ${props => (props.height ? props.height + 'px' : '32px')};
  border-radius: 5px;
  padding: ${props => (props.padding ? props.padding : '20px 8px')};
  margin: ${props => (props.margin ? props.margin : '10px 0px')};
  cursor: pointer;
  opacity: ${props => (props.opacity ? props.opacity : '100%')};
  ${({ isDisabled }) =>
  isDisabled &&
  `;
pointer-events: none;
opacity: 0.7;
`}
`;

export const CancelButton = styled.button`
  border: none;
  outline: none;
  background-color: ${Colors.transparent};
  display: flex;
  align-items: center;
  cursor: pointer;
`;
export const StyledText = styled.text`
  color: ${Colors.primaryWhite};
  font-family: ${Fonts.type.robotoRegular};
  font-size: 1.07rem;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  padding: 0px 5px;
`;
